import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { Colors, SecondaryLink, Text } from 'library';
import LogoRow from './LogoRow';
import DownloadRow from './DownloadRow';
import { useUserContext } from 'UserContext';
import { useHistory } from 'react-router';
import theme from 'theme';

export default function Footer() {
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    const history = useHistory();
    const { user } = useUserContext();

    const welcomeText = 'The platform for the modern care industry';

    return !user ? (
        <Grid container style={{ backgroundColor: Colors.darkNavy, padding: 50 }} alignItems="center">
            <Grid container direction="column" alignItems="center">
                <Text variant="display" textStyle={{ color: Colors.white }}>
                    Join Tandem
                </Text>
                <Text textStyle={{ marginTop: 20, color: Colors.white }} variant="h2">
                    {welcomeText}
                </Text>
            </Grid>
            <LogoRow />
            <DownloadRow />
        </Grid>
    ) : null;
}
